import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { tickerItems } from "@/mocks/site";

export default function TickerBar() {
  const doubled = [...tickerItems, ...tickerItems];
  const flashTarget = articles.find((item) => item.category === "flash") ?? articles[0];

  return (
    <section aria-label="首发快讯滚动条" className="border-b border-background-200 bg-foreground-950">
      <div className="mx-auto flex w-full max-w-shell items-center gap-4 px-4 py-3 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-md bg-primary-500 px-3 py-1.5 text-xs font-bold text-background-50">
          <i className="ri-flashlight-fill" aria-hidden="true" />
          首发快讯
        </span>
        <div className="relative min-w-0 flex-1 overflow-hidden">
          <div className="ticker-track flex w-max items-center gap-8">
            {doubled.map((text, index) => (
              <Link
                key={`${text}-${index}`}
                to={`/article/${flashTarget.id}`}
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap text-sm text-background-200 transition-colors hover:text-accent-300"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
                {text}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}